import { render, staticRenderFns } from "./PlayerButton.vue?vue&type=template&id=54ac3ec0"
import script from "./PlayerButton.vue?vue&type=script&lang=js"
export * from "./PlayerButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports